// Catholic prayers shown during Pomodoro breaks
export const PRAYERS = [
  {
    id: "ave_maria",
    title: "Ave Maria",
    short: "Ave Maria",
    text: "Ave Maria, cheia de graça, o Senhor é convosco. Bendita sois Vós entre as mulheres e bendito é o fruto do vosso ventre, Jesus. Santa Maria, Mãe de Deus, rogai por nós, pecadores, agora e na hora da nossa morte. Amém.",
  },
  {
    id: "pai_nosso",
    title: "Pai Nosso",
    short: "Pai Nosso",
    text: "Pai Nosso, que estais nos Céus, santificado seja o vosso nome, venha a nós o vosso Reino, seja feita a vossa vontade, assim na terra como no Céu. O pão nosso de cada dia nos dai hoje, perdoai-nos as nossas ofensas, assim como nós perdoamos a quem nos tem ofendido, e não nos deixeis cair em tentação, mas livrai-nos do mal. Amém.",
  },
  {
    id: "gloria",
    title: "Glória",
    short: "Glória",
    text: "Glória ao Pai, ao Filho e ao Espírito Santo. Como era no princípio, agora e sempre. Amém.",
  },
  {
    id: "anjo_da_guarda",
    title: "Santo Anjo do Senhor",
    short: "Anjo da Guarda",
    text: "Santo Anjo do Senhor, meu zeloso guardador, se a ti me confiou a piedade divina, sempre me rege, me guarda, me governa e me ilumina. Amém.",
  },
  {
    id: "dezena",
    title: "Dezena do Terço",
    short: "Dezena do Terço",
    text: "Reze 1 Pai Nosso, 10 Ave-Marias e 1 Glória, meditando em um dos mistérios da vida de Cristo e de Nossa Senhora.",
    isDecade: true,
  },
];

export const MYSTERIES = {
  segunda: { name: "Mistérios Gozosos", day: "Segunda-feira e Sábado" },
  terca: { name: "Mistérios Dolorosos", day: "Terça-feira e Sexta-feira" },
  quarta: { name: "Mistérios Gloriosos", day: "Quarta-feira e Domingo" },
  quinta: { name: "Mistérios Luminosos", day: "Quinta-feira" },
};

// Returns suggested mystery name for the current weekday
export function suggestedMystery() {
  const d = new Date().getDay(); // 0=Sun .. 6=Sat
  // Tradição comum:
  // Domingo: Gloriosos, Segunda: Gozosos, Terça: Dolorosos, Quarta: Gloriosos,
  // Quinta: Luminosos, Sexta: Dolorosos, Sábado: Gozosos
  const map = {
    0: "Mistérios Gloriosos",
    1: "Mistérios Gozosos",
    2: "Mistérios Dolorosos",
    3: "Mistérios Gloriosos",
    4: "Mistérios Luminosos",
    5: "Mistérios Dolorosos",
    6: "Mistérios Gozosos",
  };
  return map[d];
}
